import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';

import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { FILTER_FORM } from 'util/constants';

class FilterButton extends React.Component {

  handleClick = () => {
    const { dispatch, formName, isExport, onExport } = this.props;

    if (isExport) {
      onExport();
    } else {
      dispatch(submit(formName));
    }
  };

  render() {
    const { label = 'Search', icon } = this.props;

    return (
      <FlatButton
        primary
        label={label}
        onClick={this.handleClick}
        icon={icon}
      />
    );
  }
}

FilterButton.propTypes = {
  label: PropTypes.string,
  formName: PropTypes.string,
  resource: PropTypes.string,
  icon: PropTypes.element,
  isExport: PropTypes.bool,
  onExport: PropTypes.func,
};

FilterButton.defaultProps = {
  formName: FILTER_FORM,
  isExport: false,
  icon: <NavigationRefresh />,
};

export default connect()(FilterButton);



// WEBPACK FOOTER //
// ./src/components/button/FilterButton.js